import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles<{
  removeBottomBorder?: boolean
  removeTopBorder?: boolean
  headerAlignment?: string
}>()((theme, { headerAlignment, removeBottomBorder, removeTopBorder }) => {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      borderRadius: removeBottomBorder
        ? theme.spacing(1, 1, 0, 0)
        : removeTopBorder
          ? theme.spacing(0, 0, 1, 1)
          : theme.spacing(1),
      background: theme.palette.text.white,
      boxSizing: 'border-box',
      padding: theme.spacing(4),
    },
    iconContainer: {
      width: '28px',
      height: '28px',
      borderRadius: theme.spacing(0.5),
      background: theme.palette.bgSecondary.main,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    infoIcon: {
      width: '24px',
      height: '24px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    link: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 500,
      color: theme.palette.select.light,
      cursor: 'pointer',
    },
    header: {
      width: '100%',
      height: headerAlignment === 'normal' ? '48px' : 'auto',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      fontWeight: 500,
    },
    heading: {
      fontSize: '16px',
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: '24px',
      letterSpacing: '0.15px',
      color: theme.palette.labraText.primary,
      fontFamily: theme.typography.fontFamily,
    },
    headerTextIcon: {
      display: 'flex',
      alignItems: headerAlignment === 'normal' ? 'center' : 'normal',
      gap: theme.spacing(1),
    },
    headerLeft: {
      display: 'flex',
      alignItems: headerAlignment === 'normal' ? 'normal' : 'center',
      gap: theme.spacing(1),
    },
  }
})
